<template>
    <DynamicPopup v-if="showDynamicPopup" v-model="showDynamicPopup" @generate-standard="onStandardGenerate"
        @generate-dynamic="onDynamicGenerate"></DynamicPopup>
    <v-dialog v-model="showIntroDialog" :width="650">
        <div class="dynamic-popup comments-intro">
            <div class="popup-header">
                <div class="popup-title">
                    <img :src="require('@/assets/icons/comment-01.svg')" />
                    <span>Introducing Comments</span>
                </div>

                <button class="close-btn" @click="closeIntroPopup()">
                    <img :src="require('@/assets/icons/close.svg')" alt="">
                </button>
            </div>

            <div class="popup-subtitle">
                <span>
                    Highlight lines needing changes. Provide context for AI to understand.
                    Generate all changes together.
                </span>
            </div>

            <div class="popup-content">
                <img :src="require('@/assets/images/commentTour.png')" />

            </div>

        </div>
    </v-dialog>

    <div class="loader-container" v-if="pageLoader">
        <RotatingLoader :size="30" :speed="0.6" />
        <span>Loading Details</span>
    </div>

    <div class="create-pr-container" v-else>
        <div class="header">
            <div class="header-inner">
                <div class="header-top" v-if="!isCompletedPr">
                    <div class="header_box">
                        <button class="home-btn" @click="popupType = 'goHome'">
                            <img :src="require('@/assets/icons/home.svg')" alt="">
                        </button>
                    </div>
                    <div class="top_header_rename">
                        <span class="pr-title">{{ originalTitle }}</span>
                        <RenamePopup v-if="isEditing" :docName="originalTitle" :isEditing="isEditing"
                            @update-isEdit="isEditing = $event" @updated-prTitle="originalTitle = $event"
                            flowType="pressRelease" />
                        <button class="edit-btn" @click="editTitle">
                            <img :src="require('@/assets/icons/edit.svg')" />
                        </button>
                    </div>
                    <div></div>
                </div>
                <div class="header-left" v-else>
                    <div class="final-pr-header">
                        <div class="final-pr-header-left">
                            <button class="back-btn" @click="goback">
                                <img :src="require('@/assets/icons/back-arrow.svg')">
                            </button>
                            <span class="header-title">Press Release Details</span>
                        </div>
                        <div class="final-pr-header-right">
                            <div>
                                <button v-if="false" class="delete-pr" @click="showShareMenu = true">
                                    <div class="completed-wrappershare">
                                        <img :src="require('@/assets/icons/share.svg')"></img>
                                    </div>
                                </button>
                                <v-dialog v-model="showShareMenu" :width="400" :close-on-content-click="false">
                                    <div class="share-option-container">
                                        <div class="options-header">
                                            <p>Share Options</p>
                                            <img :src="require('@/assets/icons/close.svg')"
                                                @click="showShareMenu = false"></img>
                                        </div>
                                        <a :href="'mailto' + shareUrl" class="share-option">
                                            <img :src="require('@/assets/icons/email.svg')"></img>
                                            <p>Send as Email</p>
                                        </a>
                                        <div class="share-option" @click="handleSlackShare">
                                            <img :src="require('@/assets/icons/slack.svg')" alt="Share on Slack">
                                            <p>Share on Slack</p>
                                        </div>
                                    </div>
                                </v-dialog>
                            </div>
                            <button class="generate-pr" :disabled="downloadLoader" @click="downloadFinalPr">
                                <div class="completed-wrapper">
                                    <Svg :src="require('@/assets/icons/download.svg')" fill="white"></Svg>
                                    <p>Download</p>
                                    <v-progress-circular v-if="downloadLoader" indeterminate :size="18"
                                        :width="2"></v-progress-circular>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="comment-header"
                    v-if="showPopup && finalizedPrDetails.status === 'COMPLETED' && !commentsVisited">
                    <div class="comment-left">
                        <img :src="require('@/assets/icons/commentIcon.svg')" />
                        <div class="completed-msg">
                            <h2 class="title">Introducing the Comments</h2>
                        </div>
                    </div>
                    <div class="pr-final-header-right">
                        <button class="pr-final-btn-wrapper" @click="openIntroDialog()">
                            <p class="home-btn-text">See how it works</p>
                            <!-- <img :src="require('@/assets/icons/home.svg')" alt=""> -->
                        </button>
                        <button @click="showIntroPopup()">
                            <img :src="require('@/assets/icons/close.svg')" alt="">
                        </button>
                    </div>
                </div>

            </div>

            <div class="header-mid" v-if="this.currentStep < 4">
                <div class="step-nav" v-for="(step, index) in steps" :key="index">
                    <div
                        :class="['steps', { 'active-step': currentStep === index + 1, 'completed-step': currentStep > index + 1 }]">
                        <div class="num" v-if="currentStep <= index + 1">{{ index + 1 }}</div>
                        <div v-else class="check">
                            <img :src="require('@/assets/icons/tick-icon.svg')" />
                        </div> &nbsp;
                        <div class="step-name">{{ step }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div :class="midContent">
            <CommsBrief v-if="currentStep === 1 && !dynamicQnGenerated" v-model="staticQuestion"
                :coreDetailsQuestions="coreDetailsQuestions" :prTypeName="prTypeName"
                @update:isFormValid="updateFormValid" />
            <DynamicIntelligence v-else-if="currentStep === 1 && dynamicQnGenerated" :prTypeId="prTypeId"
                v-model="dynamicQuestion" :userInputQuestions="userInputQuestions" :subtitle="'Press Release'"
                :inputId="this.$route.params.prId" />
            <DraftOverview v-if="currentStep === 2" v-model:compareMode="compareMode" v-model:prVersions="prVersions"
                v-model:activeVersion="activePrVersion" :prTypeId="prTypeId" :prId="this.$route.params.prId"
                :prName="originalTitle" :prevStepsQues="staticAndDynamicQues" @finalizePr="finalizePr"
                @update:isEditingFinalPr="isEditingFinalPr = $event" />
            <FinalPr v-if="currentStep >= 3" :isfinalPrStepCompleted="currentStep > 3" :isCompletedPr="isCompletedPr"
                :prTypeId="prTypeId" :prId="this.$route.params.prId" v-model="finalizedPrDetails"
                @update:modelValue="handlePrUpdate" @update:isEditingFinalPr="isEditingFinalPr = $event"
                @update:toggleVersion="updateVersionType" @update:currentOriginalVersion="updateVersionNumber" />
        </div>

        <div class="footer" v-if="currentStep < 4" :class="{ 'footer--disabled': isEditingFinalPr }">
            <div class="inner-footer">
                <div class="footer-action">
                    <button class="delete-pr" @click="handleDeletePr" v-if="!compareMode">
                        <img :src="require('@/assets/icons/delete.svg')" />
                        <v-progress-circular v-if="deleteLoader" indeterminate :size="18"
                            :width="2"></v-progress-circular>
                    </button> &nbsp;&nbsp;&nbsp;
                    <button class="save-as-draft" @click="saveAsDraft" v-if="!compareMode">
                        <img :src="require('@/assets/icons/save.svg')" />
                        <p>Save as Draft</p>
                    </button>
                </div>
                <div class="footer-btn">
                    <div class="footer-right">
                        <button class="generate-pr" @click="handleGenerateClick"
                            :disabled="nextStageLoader || ((currentStep === 1 || currentStep === 2) && (!staticFormValid || smartGenerateLoader)) || (currentStep === 3 && smartGenerateLoader)"
                            v-if="(currentStep === 1) || (currentStep === 2 && compareMode === false) || currentStep === 3">
                            <div v-if="currentStep === 3" class="completed-wrapper">
                                <p>Complete</p>
                                <img :src="require('@/assets/icons/next.svg')" alt="" />
                                <v-progress-circular v-if="nextStageLoader" indeterminate :size="18" :width="2" />
                            </div>

                            <template v-else>
                                <p>{{ currentStep === 1 ? 'Generate Draft' : 'Finalize' }}</p>
                                <img :src="require('@/assets/icons/next.svg')" alt="" />
                            </template>
                        </button>

                    </div>
                </div>
            </div>
        </div>
        <CommonPopup v-if="showCommonPopup" :showCommonPopup="showCommonPopup" :popupType="popupType"
            @confirm-action="handlePopupConfirmation" />
        <v-overlay :model-value="isLoading" class="overlay" persistent="true">
            <RotatingLoader :size="30" :speed="0.6" />
            <span>{{ displayedMessage }}</span>
        </v-overlay>
        <v-overlay :model-value="smartGenerate" class="overlay" persistent="true">
            <RotatingLoader :size="30" :speed="0.6" />
        </v-overlay>
    </div>
    <ConfirmPopup v-if="confirmPopup" v-model="confirmPopup" :title="popupData.title" :image="popupData.image"
        :type="popupData.type" />

</template>

<script>
import CommsBrief from './CommsBrief.vue';
import DynamicIntelligence from './DynamicIntelligence.vue';
import DraftOverview from './DraftOverview.vue';
import CommonPopup from '@/components/CommonPopup.vue';
import FinalPr from './FinalPr.vue';

import axiosInstance from '@/axiosInterceptor';
import { Eventbus } from '@/plugins/eventBus';

import TickIcon from '@/assets/icons/next.svg';
import { saveDraft } from '@/helper/saveAsDraft';
import { downloadPr } from '@/helper/downloadPr';
import RenamePopup from '@/components/RenamePopup.vue';
import DynamicPopup from '@/components/DynamicPopup.vue';
import ConfirmPopup from '@/components/ConfirmPopup.vue';
import RotatingLoader from '@/components/CircularProgressBar.vue'
import { version } from 'vue';

export default {
    components: {
        CommsBrief,
        ConfirmPopup,
        DynamicIntelligence,
        DraftOverview,
        CommonPopup,
        RotatingLoader,
        FinalPr,
        RenamePopup,
        DynamicPopup,
    },

    data() {
        return {
            steps: ["Brief", "Draft", "Final"],
            currentStep: 0,
            originalTitle: null,
            deleteImage: require('@/assets/icons/delete_red.svg'),
            successImage: require('@/assets/icons/success.svg'),
            newTitle: null,
            isEditing: false,
            dynamicQnGenerated: false,
            showDynamicPopup: false,
            dynamicStep: false,
            showCommonPopup: false,
            popupType: null,
            showSnackbar: false,
            snackType: null,
            compareMode: false,
            TickIcon,
            prDetails: {},
            staticQuestion: {},
            updatedStaticQues: {},
            dynamicQuestion: [],
            prTypeId: null,
            savePayload: {},
            saveLoader: false,
            pageLoader: false,
            prVersions: [],
            confirmPopup: false,
            staticFormValid: false,
            smartGenerateLoader: false,
            nextStageLoader: false,
            generatePrCounter: 0,
            finalizeBtnClicked: false,
            finalizedPrDetails: {},
            deleteLoader: false,
            downloadLoader: false,
            activePrVersion: 0,
            showShareMenu: false,
            shareUrl: null,
            isCompletedPr: false,
            isLoading: false,
            pollingStatus: null,
            pollingMessages: {},
            displayedMessage: null,
            generatedPrId: null,
            popupData: {
                title: '',
                image: '',
                type: ''
            },
            isEditingFinalPr: false,
            prTypeName: null,
            userInputQuestions: null,
            refreshKey: 0,
            coreDetailsQuestions: null,
            toggleVersion: null,
            showPopup: true,
            showIntroDialog: false,
            commentsData: null,
            version: null,
            commentsVisited: null,

        }
    },
    watch: {
        currentStep() {
            document.body.scrollTop = 0;
        },
        dynamicQnGenerated() {
            document.body.scrollTop = 0;
        },
        popupType() {
            if (this.popupType) {
                this.showCommonPopup = true;
            }
        }
    },
    computed: {
        midContent() {
            return this.currentStep === 1 && !this.dynamicQnGenerated
                ? 'mid-content-with-footer'
                : 'mid-content-no-footer';
        },
        staticAndDynamicQues() {
            let staticQnPayload = this.generateStaticQnsPayload();
            let staticQuestion = [...staticQnPayload.updatedAnswer];
            let dynamicQuestions = [...this.dynamicQuestion];
            return { staticQuestion, dynamicQuestions };
        },

    },
    methods: {
        handlePrUpdate() {
            this.fetchPrDetails()

        },
        updateVersionType(val) {
            this.toggleVersion = val
        },
        updateVersionNumber(val) {
            this.version = val
        },
        onStandardGenerate() {
            this.showDynamicPopup = false;
            this.handlePrChange();
        },

        showIntroPopup() {
            this.showPopup = false;
        },
        openIntroDialog() {
            this.showIntroDialog = true;
        },
        closeIntroPopup() {
            this.showIntroDialog = false;
        },
        onDynamicGenerate() {
            this.showDynamicPopup = false;
            this.smartGenerate = true;
            this.handleSmartGenerate();
        },

        updateFormValid(val) {
            this.staticFormValid = val;
        },
        goToHome() {
            this.$router.push({ name: 'PressRelease' });
        },
        async handleSmartGenerate() {
            this.smartGenerateLoader = true;
            let staticQnPayload = this.generateStaticQnsPayload();
            await saveDraft(staticQnPayload);
            await this.fetchDynamicQuestion();

            this.smartGenerateLoader = false;
            this.smartGenerate = false;
        },

        async fetchDynamicQuestion() {
            let staticQnPayload = this.generateStaticQnsPayload();
            this.userInputQuestions = staticQnPayload.updatedAnswer

            await axiosInstance.post(`/pr/dynamicQuestions`, {
                prId: this.$route.params.prId
            })
                .then(async (response) => {
                    this.dynamicQuestion = response.data.data.questions;
                    if (this.dynamicQuestion.length != 0) {
                        this.dynamicQnGenerated = true;
                        this.dynamicQuestion.forEach((ques) => {
                            ques.isHelpful = false;
                            ques.isBetter = false;
                        });
                    }
                    else {
                        Eventbus.emit('commonSnackbar', {
                            snackType: "error",
                            message: 'Something went wrong, Please generate again'
                        });
                    }
                })
                .catch((error) => {
                    console.error('Error while fetching dynamic question', error);
                })
                .finally(() => {
                    this.quesLoader = false;
                })
        },
        async finalizePr() {
            let payload = {
                prId: this.$route.params.prId,
                versionNumber: this.prVersions[this.activePrVersion].versionNumber,
                prContent: this.prVersions[this.activePrVersion].prContent
            }
            await axiosInstance.put('/pr/finalised', payload)
                .then((response) => {
                    if (response.status === 200) {
                        this.finalizedPrDetails = this.prVersions[this.activePrVersion];
                        this.finalizedPrDetails.prName = this.originalTitle;
                        this.finalizedPrDetails.commentsVersion = [];
                        this.currentStep += 1;
                    }
                })
                .catch(() => {
                    Eventbus.emit('commonSnackbar', {
                        snackType: "failed",
                        message: 'Failed to finalized Pr'
                    });
                })
        },
        async handlePrChange() {
            if (this.currentStep === 1) {
                this.nextStageLoader = true;
                this.isLoading = true;
                this.displayedMessage = "Processing";

                try {
                    let staticQnPayload = this.generateStaticQnsPayload();
                    await saveDraft({
                        prId: this.$route.params.prId,
                        typeId: this.prTypeId,
                        updatedAnswer: staticQnPayload.updatedAnswer,
                        dynamicUpdateAnswer: this.dynamicQuestion
                    });
                    let payload = {
                        prId: this.$route.params.prId,
                        prTypeId: this.prTypeId,
                    };

                    const response = await axiosInstance.post('/pr/generate', payload);

                    if (response.status === 200) {
                        this.displayedMessage = "Completed";
                        this.isLoading = false;
                        this.nextStageLoader = false;
                        this.currentStep = 2;
                        this.activePrVersion = 0;
                        this.fetchPrDetails();
                    }

                } catch (error) {
                    console.error("Error generating PR:", error);
                    if (error.response?.status === 504 || error.code === 'ERR_NETWORK' || error.response?.status === 502) {
                        let attempts = 0;
                        let maxAttempts = 40;
                        const intervalTime = 15000;

                        const intervalId = setInterval(async () => {
                            attempts++;
                            try {
                                let isFallback = true;
                                await this.fetchPrDetails(isFallback);
                                if (this.prDetails != null && this.prDetails.prVersions.length > 0) {
                                    clearInterval(intervalId);
                                    this.displayedMessage = "Completed";
                                    this.isLoading = false;
                                    this.nextStageLoader = false;
                                    this.currentStep = 2;
                                    this.activePrVersion = 0;
                                } else if (attempts >= maxAttempts) {
                                    clearInterval(intervalId);
                                    this.isLoading = false;
                                    this.nextStageLoader = false;
                                }
                            } catch (pollError) {
                                console.error("Error during polling:", pollError);
                                clearInterval(intervalId);
                                this.isLoading = false;
                                this.nextStageLoader = false;
                                this.currentStep = 1
                                Eventbus.emit('commonSnackbar', {
                                    snackType: 'error',
                                    message: 'Failed to generate PR. Please try again later.'
                                });
                            }
                        }, intervalTime);
                    } else {
                        Eventbus.emit('commonSnackbar', {
                            snackType: "failed",
                            message: 'Failed to generate PR'
                        });
                        this.nextStageLoader = false;
                        this.isLoading = false;
                    }
                }
            } else if (this.currentStep === 2) {
                this.finalizePr();
            } else if (this.currentStep === 3) {
                this.nextStageLoader = true;
                this.staticFormValid = true;
                let payload = {
                    prId: this.$route.params.prId,
                    prTypeId: this.prTypeId,
                    versionNumber: this.finalizedPrDetails.versionNumber
                };
                await axiosInstance.put('/pr/complete', payload)
                    .then((response) => {
                        if (response.status === 200) {
                            this.currentStep = 4;
                        }
                    })
                    .catch(() => {
                        Eventbus.emit('commonSnackbar', {
                            snackType: "failed",
                            message: 'Failed to complete PR'
                        });
                    })
                    .finally(() => {
                        this.nextStageLoader = false;
                    });
            }
        },

        handleGenerateClick() {
            if (this.currentStep === 1 && !this.dynamicQnGenerated) {
                this.showDynamicPopup = true;
            }
            else if (this.currentStep === 2) {
                this.finalizePr();
            }
            else {
                this.handlePrChange()
            }
        },

        editTitle() {
            this.isEditing = true;
        },

        goback() {
            this.$router.go(-1);
        },

        handleDeletePr() {
            this.popupType = 'delete'
            this.showCommonPopup = true;
        },

        generateStaticQnsPayload() {
            let updatedAnswer = [
                ...(this.staticQuestion.questions || []),
                ...(this.coreDetailsQuestions || [])
            ];
            const payload = {
                prId: this.$route.params.prId,
                typeId: this.prTypeId,
                updatedAnswer,
            }
            return payload;
        },
        async handlePopupConfirmation(val) {
            this.showCommonPopup = false;
            if (val === 'yes') {
                if (this.popupType === 'delete') {
                    this.deleteLoader = true;
                    axiosInstance.put('/pr/delete', { prId: this.$route.params.prId, prTypeId: this.prTypeId })
                        .then((response) => {

                            if (response.status === 204) {
                                this.popupData = {
                                    title: 'PR discarded',
                                    image: this.deleteImage,
                                    type: 'success'
                                };
                                this.confirmPopup = true;
                                setTimeout(() => {
                                    this.$router.push({ name: 'PressRelease' });
                                }, 1000);
                            }
                        })
                        .catch((error) => {
                            console.error('Error while deleting PR', error);
                            Eventbus.emit('commonSnackbar', {
                                snackType: "failed",
                                message: 'Failed to delete PR'
                            });
                        })
                        .finally(() => {
                            this.deleteLoader = false;
                        })
                }
                else if (this.popupType === 'saveAsDraft') {
                    let result;
                    let redirection = {
                        name: "PressRelease"
                    }
                    if (this.currentStep === 1 && !this.dynamicQnGenerated) {
                        let staticQnPayload = this.generateStaticQnsPayload();
                        result = await saveDraft(staticQnPayload, redirection);
                    } else if (this.currentStep === 1 && this.dynamicQnGenerated) {
                        let staticQnPayload = this.generateStaticQnsPayload();
                        let dynamicQuestionPayload = {
                            prId: this.$route.params.prId,
                            typeId: this.prTypeId,
                            updatedAnswer: staticQnPayload.updatedAnswer,
                            dynamicUpdateAnswer: this.dynamicQuestion
                        }
                        result = await saveDraft(dynamicQuestionPayload, redirection);
                    } else if (this.currentStep === 2) {
                        const draftOverViewPayload = {
                            prId: this.$route.params.prId,
                            typeId: this.prTypeId,
                            prTitle: this.prVersions[this.activePrVersion].prTitle,
                            prContent: this.prVersions[this.activePrVersion].prContent,
                            versionNumber: this.prVersions[this.activePrVersion].versionNumber
                        }

                        result = await saveDraft(draftOverViewPayload, redirection);


                    } else if (this.currentStep === 3) {
                        let finalizedPrPayload = { ...this.finalizedPrDetails };
                        finalizedPrPayload.typeId = this.prTypeId;

                        result = await saveDraft(finalizedPrPayload, redirection);
                    }

                    if (result?.success) {
                        this.popupData = result.data;
                        this.confirmPopup = true;
                        setTimeout(() => {
                            this.confirmPopup = false;
                            this.$router.push({ name: 'PressRelease' });
                        }, 1000);

                    }

                }
                else {
                    this.$router.push({ name: 'PressRelease' });
                }
            }
            this.popupType = null;
        },

        handleSnackbar() {
            if (this.snackType === 'save') {
                this.$router.push('/');
            }
            this.showSnackbar = false;
            this.snackType = null;
        },

        saveAsDraft() {
            this.popupType = 'saveAsDraft'
            this.showCommonPopup = true;
        },
        // handleSlackShare() {
        //     const slackProps = {
        //         url: window.location.href,
        //         text: 'Check this out on Slack!',
        //     };

        //     const message = `${slackProps.text} ${slackProps.url}`;

        //     const slackUrl = `slack://share?text=${encodeURIComponent(message)}`;

        //     window.location.href = slackUrl;
        //     this.showShareMenu = false;
        // },


        goToDashboard() {
            this.$router.push('/');
        },

        async downloadFinalPr() {
            this.downloadLoader = true;
            let versionNumber;
            if (this.version === 'final') {
                versionNumber = this.finalizedPrDetails.versionNumber;
            } else {
                versionNumber = Number(this.version.slice(1));
            }
            let payload = {
                prId: this.$route.params.prId,
                version: versionNumber,
                flowType: "PR",
                versionType: this.toggleVersion
            }
            let filename;
            const title = this.finalizedPrDetails.prTitle;

            if (this.toggleVersion === 'mediaPitch') {
                filename = `${title}_mediapitch`;
            } else if (this.version === 'final') {
                filename = `${title}_final`;
            } else {
                filename = `${title}_version_${versionNumber}`;
            }

            await downloadPr(payload, filename);
            this.downloadLoader = false;
        },

        async fetchQuestions() {
            await axiosInstance.get(`/question/${this.prTypeId}`)
                .then((response) => {
                    this.staticQuestion = response.data.data;

                    const sortByOrder = (array) => {
                        return array?.sort((a, b) => a.orderNumber - b.orderNumber) || [];
                    };

                    if (this.staticQuestion.questions && this.staticQuestion.questions.length > 0) {
                        this.staticQuestion.questions = sortByOrder(this.staticQuestion.questions);
                        this.staticQuestion.questions.forEach(item => {
                            item.answer = null;
                            if (item.responseType === 'date') {
                                item.showDateMenu = false;
                                item.displayDateVariable = null;
                            }
                        });
                    }
                    this.coreDetailsQuestions = this.staticQuestion.questions.filter(q => q.questionType === 'CoreDetails');

                    // Step 2: Remove CoreDetails questions from the original array
                    this.staticQuestion.questions = this.staticQuestion.questions.filter(q => q.questionType !== 'CoreDetails');


                    if (this.staticQuestion.DYN_FEATURE) {
                        let newQuestion = {
                            dynamicFeatures: [
                                {
                                    name: null,
                                    description: null
                                }
                            ]
                        };
                        switch (this.prTypeName) {
                            case 'Product Launch': {
                                this.staticQuestion.questions = [
                                    ...this.staticQuestion.questions.slice(0, 6),
                                    newQuestion,
                                    ...this.staticQuestion.questions.slice(6)
                                ];
                                break;
                            }
                        }
                    }

                    if (this.staticQuestion.QUOTE) {
                        let newQuote = {
                            quoteDetails: [
                                {
                                    quoteDetails: null,
                                }
                            ]
                        };
                        switch (this.prTypeName) {
                            case 'General': {
                                this.staticQuestion.questions = [
                                    ...this.staticQuestion.questions.slice(0, 6),
                                    newQuote,
                                    ...this.staticQuestion.questions.slice(6)
                                ];
                                break;
                            }
                            case 'Funding/M&A': {
                                this.staticQuestion.questions = [
                                    ...this.staticQuestion.questions.slice(0, 13),
                                    newQuote,
                                    ...this.staticQuestion.questions.slice(13)
                                ];
                                break;
                            }
                            case 'Product Launch': {
                                this.staticQuestion.questions = [
                                    ...this.staticQuestion.questions.slice(0, 8),
                                    newQuote,
                                    ...this.staticQuestion.questions.slice(8)
                                ];
                                break;
                            }

                            case 'Event Announcement': {
                                this.staticQuestion.questions = [
                                    ...this.staticQuestion.questions.slice(0, 16),
                                    newQuote,
                                    ...this.staticQuestion.questions.slice(16)
                                ];
                                break;
                            }
                        }
                    }
                })
        },

        async fetchPrDetails(isFallback = false) {
            if (!isFallback) {
                this.pageLoader = true;
            }
            await axiosInstance.get(`/pr/${this.$route.params.prId}`)
                .then(async (response) => {


                    this.prDetails = response.data.data;
                    this.originalTitle = this.prDetails.prName;
                    this.prTypeId = this.prDetails.prTypeId;
                    this.commentsData = this.prDetails.commentsData;
                    this.commentsVisited = this.prDetails.commentsVisited
                    if (this.prDetails?.finalizedPr) {
                        this.finalizedPrDetails = this.prDetails?.finalizedPr;
                        this.finalizedPrDetails.prContent = this.finalizedPrDetails.prContent.replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '').replace(/<ul(?![^>]*style=)/gi, `<ul style="padding-left: 1rem;"`).replace(/<ol(?![^>]*style=)/gi, `<ol style="padding-left: 1rem"`);
                        this.finalizedPrDetails.prName = this.originalTitle;
                        this.finalizedPrDetails.commentsData = this.commentsData;
                        this.finalizedPrDetails.commentsVersion =
                            this.prDetails.commentsVersion ?? [];
                        if (this.finalizedPrDetails?.status === 'COMPLETED') {
                            this.finalizedPrDetails.mediaPitch = this.prDetails.mediaPitch;
                            this.isCompletedPr = true;
                            this.currentStep = 4;
                        } else {
                            this.currentStep = 3;
                        }
                    } else if (this.prDetails?.prVersions && this.prDetails?.prVersions.length > 0) {
                        this.currentStep = 2;
                        this.prVersions = this.prDetails.prVersions;
                        this.prVersions = this.prVersions.map(pr => ({
                            ...pr,
                            prContent: pr.prContent.replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '')
                        }));

                        this.staticFormValid = true
                        // For sending the static and dynamic questions in refine & generate titles API calls
                        this.staticQuestion = {};
                        this.staticQuestion.questions = this.prDetails.question[0].responseObjectWithQuestionId;
                        this.dynamicQuestion = this.prDetails.question[0].dynamicContentWithQuestion;

                    } else {
                        this.currentStep = 1;
                        this.prTypeName = this.prDetails.prTypeName;
                        if (this.prDetails?.question) {
                            if (this.prDetails.question[0]?.dynamicContentWithQuestion?.length > 0) {
                                this.dynamicQuestion = this.prDetails.question[0].dynamicContentWithQuestion;
                                this.staticQuestion.questions = this.prDetails.question[0].responseObjectWithQuestionId;
                                this.coreDetailsQuestions = this.staticQuestion.questions.filter(q => q.questionType === 'CoreDetails');

                                // Step 2: Remove CoreDetails questions from the original array
                                this.staticQuestion.questions = this.staticQuestion.questions.filter(q => q.questionType !== 'CoreDetails');

                                this.dynamicQnGenerated = true;
                                this.staticFormValid = true
                            } else if (this.prDetails.question[0]?.responseObjectWithQuestionId?.length > 0) {
                                this.staticQuestion = {};
                                this.staticQuestion.questions = this.prDetails.question[0].responseObjectWithQuestionId;

                                this.coreDetailsQuestions = this.staticQuestion.questions.filter(q => q.questionType === 'CoreDetails');

                                // Step 2: Remove CoreDetails questions from the original array
                                this.staticQuestion.questions = this.staticQuestion.questions.filter(q => q.questionType !== 'CoreDetails');
                            }
                        } else {
                            await this.fetchQuestions();
                        }
                    }
                })
                .catch((error) => {
                    console.error('Error while fetching PR details', error);
                })
                .finally(() => {
                    this.pageLoader = false;
                })
        }
    },
    async mounted() {
        await this.fetchPrDetails();
        this.shareUrl = process.env.VUE_APP_BASE_URL + window.location.href;
    }
}
</script>

<style scoped>
.comments-intro {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    gap: 10px;
}

.popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.popup-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    font-size: var(--header-font-size);
}

.close-btn {
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
}

.popup-subtitle {
    font-size: var(--normal-font-size);
    color: #6b7280;
}

.create-pr-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: var(--dark-background);
    background-size: 100% 100%;
}

.header {
    position: sticky;
    top: 0;
    right: 0;
    left: 0;
    padding: 0px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background: #FFFFFF09;
    border-bottom: 1px solid #FFFFFF33;
    color: white;
    z-index: 100;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 16px;
    color: white;
}

.comment-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1.5em;
    background: white;
    padding: 0.6rem 1.5rem;
    color: var(--secondary-font-color);
    justify-content: space-between;
}

.pr-final-header-right {
    display: flex;
    flex-direction: row;
    gap: 2rem;
}

.pr-final-btn-wrapper {
    display: flex;
    gap: 0.5em;
    justify-content: center;
    background: #FFC6FB;
    border: 1px solid #FFFFFF33;
    align-items: center;
    padding: 0.5rem 1rem;
    border-radius: 8px;
    color: var(--primary-font-color);
    font-size: var(--normal-font-size);
}

.comment-left {
    display: flex;
    gap: 1rem;
}

.completed-msg {
    display: flex;
    flex-direction: column;
    gap: 2px;
    color: black;
    font-size: 12px;
}

.final-pr-header {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    padding: 1rem 1.5rem;
}

.final-pr-header-left {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 12px;
}

.final-pr-header-right {
    display: flex;
    flex-direction: row;
    gap: 12px;
}

.download_btn {
    margin-left: 20px;
}

.back-btn {
    height: 2.5rem;
    width: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1em;
    background-color: #FFFFFF;
    border: 1px solid #E5E5E5;
    border-radius: 50%;
}

.header-title {
    font-size: 18px;
    font-weight: 500;
}

.pr-title {
    font-weight: 500;
    text-align: center;
}

.edit-title-input {
    width: 200px;
    align-items: center;
}

.edit-btn {
    display: flex;
    padding: 8px 8px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
    align-items: center;
    cursor: pointer;
    margin: 10px 5px;
}

.header-mid {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.top-header-actions {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.header-inner {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.step-nav {
    display: flex;
    align-items: center;
    width: 34%;
    justify-content: space-around;
    align-items: center;
}

.steps {
    width: 100%;
    gap: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.08);
    padding: 8px 12px;
    color: #D4D4D4;
    cursor: pointer;
}

.active-step {
    background: linear-gradient(90deg, #FF00C3, #FF0A19, #FF7800), rgba(0, 0, 0, 0.6);
    background-blend-mode: multiply;
    color: white;
}


.completed-step {
    position: relative;
    background-color: #5F003F;
    opacity: 0.7;
    color: #E5E5E5;
    border: 1px solid rgb(121, 19, 87);
}

.completed-step::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    opacity: 0.2;
    z-index: -1;
    border-radius: 50px;
}

.active-step .num {
    background-color: rgba(223, 0, 158, 1);
    color: #ffffff;
}

.check {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    padding: 12px;
    border-radius: 50%;
    background-color: #FF00C3;
    color: white;
}

.step-name {
    font-size: 14px;
}

.num {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    padding: 12px;
    border-radius: 50%;
    background-color: #737373;
    color: #D4D4D4;

}

.next-step {
    transform: rotate(270deg);
}

.delete-pr {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
}

.save-as-draft {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 24px 8px 24px;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
}

.save-as-draft p {
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    letter-spacing: -3%;
}

.header-top {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.header_box {
    width: 5%;
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.top_header_rename {
    width: 95%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.home-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFF1F;
    border-radius: 8px;
    padding: 12px;

}

.generate-pr {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 40px;
    gap: 8px;
    border-radius: 8px;
    opacity: 0.8;
    background: var(--primary-gradient-with-black)
}

.completed-wrapper {
    display: flex;
    align-items: center;
    gap: 0.5em;
}

.completed-wrappershare {
    display: flex;
    align-items: center;
    gap: 0.5em;
}

.completed-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px;
    background-color: #FFFFFF;
    border-radius: 50%;
}

.share-option-container {
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    box-shadow: 0px 4px 8px 0px #0000000F;
    box-shadow: 0px 0px 4px 0px #0000000A;
    min-width: 300px;
    font-family: monospace;
    text-transform: uppercase;
}

.options-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1em;
    border-bottom: 1px solid #E5E5E5;
    color: #737373;
}

.options-header svg {
    cursor: pointer;
}

.share-option {
    display: flex;
    align-items: center;
    gap: 1em;
    padding: 1em;
    color: #404040;
    text-decoration: none;
    cursor: pointer;
}

.mid-content-with-footer,
.mid-content-no-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    scrollbar-width: thin;
    will-change: transform;
}

.footer {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px 48px;
    background: #180914;
    border-top: 1px solid #FFFFFF33;
    color: white;
    z-index: 100;
}

.footer--disabled {
    pointer-events: none;
    opacity: 0.5;
    filter: grayscale(0.8);
}

.inner-footer {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.footer-action {
    display: flex;
    flex-direction: row;
    width: 50%;
}

.footer-btn {
    width: 50%;
    max-width: 1024px;
    display: flex;
    justify-content: flex-end;
}

.footer-left {
    position: relative;
    border-radius: 8px;
    padding: 4px;
    margin: 0px 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(59.39deg, rgba(255, 0, 195, 0.233), rgba(255, 10, 26, 0.11));
}

.footer-left::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    padding: 1px;
    /* Same as border width */
    background: linear-gradient(to right, rgba(255, 0, 195, 1), rgba(255, 10, 25, 1), rgba(255, 120, 0, 1));
    -webkit-mask: linear-gradient(white 0 0) content-box, linear-gradient(white 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
}


.i-btn {
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FFFFFF14;
    border: 1px solid #FFFFFF33;
    border-radius: 6px;
    padding: 12px 0px;
    margin: 0px 5px;
}

.fine-tune-section {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.fine-tune-right-actions {
    display: flex;
    flex-direction: row;
}

.dynamic {
    width: 30px;
    height: 30px;
    margin: 0px 10px;
}

.name {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.label {
    color: #D4D4D4;
    font-size: 14px;
}

.name-end-wrapper {
    font-size: 15px;
}

.footer-right {
    display: flex;
    gap: 12px;
    align-items: center;
}

.know-more {
    display: flex;
    height: 50px;
    justify-content: center;
    align-items: center;
    padding: 8px 20px;
    gap: 12px;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
}

.generater {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    border-radius: 8px;
    gap: 8px;
    margin: 0px 10px;
    color: white;
    background: linear-gradient(86.34deg, rgba(255, 0, 195, 0.5) 7.5%, rgba(255, 10, 25, 0.5) 50.5%, rgba(255, 120, 0, 0.5) 96%);
    border: 1px solid transparent;
}

.generater:disabled {
    opacity: 0.9;
    cursor: not-allowed;
}

.overlay {
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    z-index: 9999;
}

.overlay :deep(.v-overlay__content) {
    display: flex;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    gap: 1rem;
}
</style>